import React, { useEffect, useState } from 'react'
import { BASE_URL_2 } from './config';
import axios from 'axios';
import { toast } from 'react-toastify';

const useDashboard = () => {
  const [myEarning,setMyEarning] = useState({});
  const [loadingEarning,setLoadingEarning] = useState(false);
  const [jobsData,setJobsData] = useState([]);
  
  useEffect(()=>{
  setLoadingEarning(true);
  axios.get(`${BASE_URL_2}job/vendor/get_earnings/`,{withCredentials:true})
  .then(res =>{
    // console.log(res,"EarningApiCall");
    setLoadingEarning(false);
   if(res?.data?.success) setMyEarning({...res?.data?.data})
  //  else toast.error("Something went wrong")
  })
  .catch(err =>{
    toast.error(err?.data?.error);
    setLoadingEarning(false);
  })
  },[])

  useEffect(()=>{
   if(window.location.href.includes("/dashboard")){
    setLoadingEarning(true);
    axios.get(`${BASE_URL_2}job/vendor/dashboard/job_count/`,{withCredentials:true})
    .then(res =>{
      setLoadingEarning(false);
      setJobsData({...res?.data?.data});
    })
    .catch(err =>{
     toast.error(err?.data?.error);
     setLoadingEarning(false);
    })
   }
},[])



  return [myEarning,jobsData,loadingEarning]
   
}

export default useDashboard

